
import $ from "jquery";
import {showCalendarItem} from "../../scripts/calendar.js";
import breadcrumb from './breadcrumb';
import "fantdu/dist/fantdu.min";


export default function(){
    
    showCalendarItem();
    const breadcrumbHtml = breadcrumb();
    let nameId = client.nameId || "";
    
    
    return `
    
        <div class="container">
            ${breadcrumbHtml}
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="calendar__event__container">
                    
                        
                        <div class="spinner-border align-self-center" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                                        
                    
                    </div>
                </div>
            </div>
        </div>
        <div class="fant_du_container">
            <fant-du client="${nameId}" onSubmitSuccess="fantdu__success" onSubmitFail="fandu__failed" css="
            :host{
                display:block;
                min-width:320px;
            }
            
            .fant-du__center{
                text-align:center;
            }
            
            .fant-du__heading{
                font-family: inherit;
                font-size: 24px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: center;
                color: #1e1e1e;
                margin-bottom:15px;
            }
            
            .fant-du__buttons{
                display:flex;
                justify-content:center;
                margin: 0 auto;
            }
            
            .fant-du__button{
                border: none;
                padding: 12px 0;
                width: 112px;
            
                border-radius:4px;
                border: 3px solid #fff;
                font-family: inherit;
                font-size: 18px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #1e1e1e;
                background:#fff;
            }
            
            .fant-du__textarea{
                border-radius: 4px;
                background-color: rgba(112, 112, 112, 0.05);
                border:1px solid #555555;
                padding:14px 16px;
                font-family: inherit;
                font-size: 16px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #555555;
                margin: 2px 2px 20px 2px;
            }
            
            .fant-du__receipt{
                font-family: inherit;
                font-size: 16px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: center;
                color: #1e1e1e;
            }
            
            .fant-du__textarea:focus{
                border: 3px solid #385dff;
                outline:none;
                margin: 0 0 17px 0;
            }
            
            .fant-du__button:hover{
                cursor:pointer;
            }
            
            .fant-du__button--yes{
                border-color:#008800;
                margin-right:25px;
            }
            
            .fant-du__button--yes:hover,
            .fant-du__button--yes:focus{
                background-color:#008800;
                color:#fff;
            }
            
            .fant-du__button--yes:active{
                border-radius: 4px;
                border-color: rgba(0,0,0,0.25);
                outline:0;
            }
            
            .fant-du__button--no{
                border-color:#cc0000;
            }
            
            .fant-du__button--no:hover,
            .fant-du__button--no:focus{
                background-color:#cc0000;
                color:#fff;
            }
            
            .fant-du__button--no:active{
                border-radius: 4px;
                border-color: #950000;
                outline:0;
            }
            
            .fant-du__button--submit{
                border-color:#385dff;
                background:#385dff;
                color:#fff;
                width: 170px;
                display:block;
                margin: 0 auto;
            }
            
            .fant-du__button--submit:hover,
            .fant-du__button--submit:focus{
                background-color:#1b41eb;
            }
            
            .fant-du__button--submit:active{
                border-radius: 4px;
                border-color: #01146c;
                outline:0;
            }
            
            .fant-du__mb-10{
                margin-bottom:10px !important;
            }
            .fant-du__mb-30{
                margin-bottom:30px !important;
            }"></fant-du> 
        </div>
        
    `;
}